import { render } from "./session-wrapper.vue?vue&type=template&id=2802f9a0"
import script from "./session-wrapper.vue?vue&type=script&lang=js"
export * from "./session-wrapper.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__